import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../utils/supabase';
import './AuthCallback.css';
import { getCookie, parseConsent, CONSENT_VERSION } from './PrivacyBanner';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth callback error:', error);
          navigate('/login');
          return;
        }

        if (data.session) {
          // Fire-and-forget consent persistence. We never block the redirect
          // on this request — a slow/hung /api/consent/persist must not trap
          // the user on the callback screen.
          try {
            const raw = getCookie('privacy_consent');
            const c = parseConsent(raw);
            if (c) {
              const controller = new AbortController();
              const timeoutId = setTimeout(() => controller.abort(), 5000);
              fetch('/api/consent/persist', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${data.session.access_token}`
                },
                body: JSON.stringify({ version: CONSENT_VERSION, necessary: c.necessary, analytics: c.analytics }),
                signal: controller.signal
              })
                .catch(() => {})
                .finally(() => clearTimeout(timeoutId));
            }
          } catch (_) {}
          navigate('/');
        } else {
          // No session found, redirect to login
          navigate('/login');
        }
      } catch (error) {
        console.error('Auth callback processing error:', error);
        navigate('/login');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="auth-callback">
      <h2>Processing authentication...</h2>
      <p>Please wait while we complete your sign-in.</p>
    </div>
  );
};

export default AuthCallback;
